import { FluentProvider } from "@/dependencies";
import {
  makeStyles,
  mergeClasses,
  TagPickerControl,
  TagPickerControlProps,
} from "@fluentui/react-components";

interface TagPickerControlCustomProps {
  rcName?: string;
  theme?: string;
  disabled?: boolean;
}

const useStyles = makeStyles({
  root: {
    "& .fui-Tag__primaryText": {
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
  },
  disabled: {
    backgroundColor: "var(--colorSubtleBackgroundHover)",
    "& .fui-Tag__primaryText": {
      color: "var(--colorNeutralForeground1)",
    },
    "& button": {
      backgroundColor: "var(--colorNeutralBackground2Selected)",
    },
    "& input": {
      color: "var(--colorNeutralForeground1)",
    },
  },
});

const TagPickerControlCustom = (
  props: TagPickerControlCustomProps & TagPickerControlProps,
) => {
  const styles = useStyles();
  return props.theme ? (
    <FluentProvider theme={props.theme}>
      <TagPickerControl
        {...props}
        className={mergeClasses(
          styles.root,
          props.disabled ? styles.disabled : "",
          props.className,
        )}
      />
    </FluentProvider>
  ) : (
    <TagPickerControl
      {...props}
      className={mergeClasses(
        styles.root,
        props.disabled ? styles.disabled : "",
        props.className,
      )}
    />
  );
};

export default TagPickerControlCustom;
